<div class="flex-column f-1-0">
	<ng-container *ngFor="let condition of conditionArr; let first = first; let orIndex = index">
		<span class="fw-bold opacity-75" style="color: #486db5; margin: 8px 5px;" *ngIf="!first">OR</span>
		<ng-container *ngTemplateOutlet="conditionHtml; context: {$implicit: condition, orIndex}"></ng-container>
	</ng-container>
</div>

<ng-template #conditionHtml let-condition let-orIndex="orIndex">
	<div class="flex-row gap-4 align-items-center f-1-0">

		<!--Select condition type-->
		<app-dropdown-c style="width: 180px; --dropdown-menu-width: 800px;" (click)="clearSearchCondition();"
						text="{{rulesOptions.types[condition.type].label}}">
			<ul style="overflow: auto; min-height: 110px;">
				<li class="static-item" style="min-height: 0;" (click)="$event.stopPropagation()">
					<div class="search-box flxRow" style="position: relative; max-width: 300px;">
						<input type="search" class="w-100"
							   [(ngModel)]="searchConditionText"
							   maxlength="{{dic.CONSTANTS.maxCharsInSearch}}"
							   (keyup)="searchCondition(searchConditionText);"
							   placeholder="Search condition">
						<a class="closeRed animated fadeIn"
						   id="clearSearchCondition"
						   (click)="clearSearchCondition();"
						   *ngIf="searchConditionText"
						   style="font-size: 16px; color: #cccccc; position: absolute; right: 15px; top: calc(50% + 1px); transform: translateY(-50%);">
							<i class="zmdi zmdi-close"></i>
						</a>
					</div>
				</li>
				<div class="flex-row flex-wrap overflow-auto" style="max-height: 40vh;">
					<li *ngFor="let item of rulesOptions.types | keyvalue: gs.returnZero"
						class="flex-column w-50" style="gap: 3px;"
						[hidden]="rulesOptions.types[item.key].hide"
						(click)="changeConditionType(condition, item.key)">
						<span class="fw-500" style="font-size: 14px;">{{rulesOptions.types[item.key].label}}</span>
						<i style="color: #505050; font-size: 12px;">{{rulesOptions.types[item.key].tooltip}}</i>
					</li>
					<li *ngIf="searchResultNotFound" class="d-flex centralize py-3" (click)="$event.stopPropagation()">
						No items found
					</li>
				</div>
			</ul>
		</app-dropdown-c>

		<ng-container *ngIf="condition.type !== dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.name">
			<span class="text-nowrap">
				detected in
				<ng-container *ngIf="condition.type !== dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.name && !rulesOptions.types[condition.type].subTypes">
					{{condition.type === dic.CONSTANTS.collaborationProtectionRule.types.keywords.name ? 'message' :
					  condition.type === dic.CONSTANTS.collaborationProtectionRule.types.attachment_types.name ? 'file' : 'message or file'}}
				</ng-container>
			</span>

			<ng-container *ngIf="rulesOptions.types[condition.type].subTypes">
				<!--Select condition subtype (single)-->
				<div *ngIf="condition.singleSubType">
					<app-dropdown-c class="animated fadeIn" style="width: 150px;"
									text="{{condition.subType[0]}}"></app-dropdown-c>
				</div>
				<!--Select condition subtype (multiple)-->
				<div *ngIf="!condition.singleSubType">
					<app-dropdown-c style="width: 150px;" id="{{'rulesPoliciesDropdownSubType' + conditionIndex}}"
									[error]="condition.invalidSubTypes"
									[text]="condition?.subTypeShow?.join(', ') || 'Choose'">
						<ul>
							<li *ngFor="let item of dic.CONSTANTS.collaborationProtectionRule.types[condition.type].subTypes| keyvalue: gs.returnZero"
								[explanationC]="condition.type === dic.CONSTANTS.collaborationProtectionRule.types.keywords.name ? item.key === 'body' ? 'Content body - including file names' : 'Subject' :
												item.key === 'source' ? 'The sender of the message or the file uploader' : item.key === 'recipient' ? 'The recipient of the message or a member in the chat/channel' : null"
								(click)="condition.subType[item.key] = !condition.subType[item.key]; subtypeChanged(condition); $event.stopPropagation();"
								id="{{'rulesPoliciesSubTypeValue' + item.key + conditionIndex}}">
								<checkbox (click)="$event.preventDefault();"
										  [(model)]="condition.subType[item.key]">
									{{item.key}}
								</checkbox>
							</li>
						</ul>
					</app-dropdown-c>
				</div>
			</ng-container>
		</ng-container>

		<!--connection word(s)-->
		<a class="flex-row text-nowrap blue-link text-decoration-underline"
		   [ngClass]="{'text-danger' : condition.is_negate}"
		   (click)="condition.is_negate = !condition.is_negate;">
			<span>{{dic.CONSTANTS.collaborationProtectionRule.types[condition.type].isPlural ? 'are' : 'is'}}</span>
			<span class="fw-500" *ngIf="condition.is_negate">&nbsp;NOT</span>
			<span *ngIf="condition.type === dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_score.name">
				&nbsp;equal or above
			</span>
		</a>

		<!--match type dropdown-->
		<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.collaborationProtectionRule?.types?.addresses?.name ||
							   condition.type === dic.CONSTANTS.collaborationProtectionRule?.types?.keywords?.name ||
							   condition.type === dic.CONSTANTS.collaborationProtectionRule?.types?.sensitivity_type?.name"
						style="width: 190px;"
						(click)="showMatchActions(condition);"
						text="{{condition?.data?.matchType}}">
			<ul>
				<li *ngFor="let matchTypeVal of condition.actions"
					(click)="changeMatchType(matchTypeVal, condition);">
					<span [explanationC]="dic.CONSTANTS.ruleMatchTypeTooltip[matchTypeVal]">
						{{matchTypeVal}}
					</span>
				</li>
			</ul>
		</app-dropdown-c>

		<ng-container *ngIf="condition.type === dic.CONSTANTS.collaborationProtectionRule?.types?.sensitivity_type?.name && condition.data?.matchType === dic.CONSTANTS.ruleMatchType.moreThan">
			<div class="flex-row align-items-center gap-1 text-nowrap">
				<input type="number" style="width: 45px; margin: 0 2px;" min="1" max="10"
					   [(ngModel)]="condition.data.matchCount">
				<span>times</span>
			</div>
		</ng-container>

		<!--select values-->
		<ng-container [ngSwitch]="condition.type">

			<!--sensitivity score-->
			<input *ngSwitchCase="dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_score.name"
				   type="number" min="1" max="5" step="0.1"
				   id="{{'collaborationRuleSensitivityScore' + conditionIndex}}"
				   pattern="/^[1-5]\.?[0-9]?$/"
				   (ngInit)="condition.data.score_more = condition.data.score_more || 4"
				   [(ngModel)]="condition.data.score_more" />

			<!--compliance-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.collaborationProtectionRule.types.compliance.name"
							style="width: 150px;"
							text="{{condition?.data?.complianceShow?.join(', ') || 'Choose'}}"
							[error]="condition?.invalidCompliance"
							id="{{'collaborationRuleDropdownCompliance' + conditionIndex}}">
				<ul>
					<li *ngFor="let item of condition.data.compliance| keyvalue: gs.returnZero"
						(click)="condition.data.compliance[item.key].enabled = !condition.data.compliance[item.key].enabled; condition.invalidCompliance = false; updateComplianceShow(condition.data); $event.stopPropagation()"
						id="{{'collaborationRuleComplianceValue' + item.key + conditionIndex}}">
						<checkbox (click)="$event.preventDefault();" [model]="condition.data.compliance[item.key].enabled">
							{{item.key}}
						</checkbox>
					</li>
				</ul>
			</app-dropdown-c>

			<!--keywords-->
			<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.collaborationProtectionRule.types.keywords.name && (condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.exactMatch || condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.contains)"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.keywords?.length ? '' : 'darkgrey', 'font-size': condition?.data?.keywords?.length ? '' : '11.4px'}"
							(click)="showPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.keywords?.join(' , ') || 'Click to add Keywords'}}"
							[renderAsPlainText]="true"
							[error]="condition?.invalidKeywords">
			</app-dropdown-c>

			<!--addresses-->
			<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.collaborationProtectionRule.types.addresses.name &&
								   [dic.CONSTANTS.ruleMatchType.exactMatch, dic.CONSTANTS.ruleMatchType.startsWith, dic.CONSTANTS.ruleMatchType.endsWith, dic.CONSTANTS.ruleMatchType.contains].indexOf(condition?.data?.matchType) > -1"
							style="width: 200px;" tooltip="Click to view and edit"
							[ngStyle]="{'color' : condition?.data?.emails?.length ? '' : 'darkgrey',
											 'font-size': condition?.data?.emails?.length ? '' : '11.4px'}"
							(click)="showPopup(condition)"
							text="{{condition?.data?.emails?.join(' , ') || 'Click to add email addresses'}}"
							[error]="condition.invalidEmails"></app-dropdown-c>

			<!--attachment types-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.collaborationProtectionRule.types.attachment_types.name"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.attachment_types?.length ? '' : 'darkgrey', 'font-size': condition?.data?.attachment_types?.length ? '' : '11.4px'}"
							(click)="showAttachmentTypesPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.all_types ? 'any type' : condition?.data?.attachment_types?.length ? condition?.data?.typesDisplay : 'Click to add attachment types'}}"
							[error]="condition?.invalidAttachmentsTypes">
			</app-dropdown-c>

			<!--sensitivity_type-->
			<a *ngSwitchCase="dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_type?.name"
			   class="blue-link text-center" style="word-break: keep-all;"
			   (click)="openSensitivityTypesPopup(condition)"
			   [tooltip]="condition?.data?.sensitivity_types && condition?.data?.sensitivity_types?.length ? condition?.data?.sensitivity_types?.join(', ') : ''"
			   [ngClass]="{'validation-error': condition.invalidSensitivityType}">
				<ng-container *ngIf="condition.data.sensitivity_types?.length">
					{{condition.data.sensitivity_types.length}} types selected <span class="text-nowrap">(click to edit)</span>
				</ng-container>
				<ng-container *ngIf="!condition.data.sensitivity_types?.length">
					Select sensitivity types
				</ng-container>
			</a>

			<!--resource type-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.name"
							style="width: 200px;"
							text="{{condition?.data?.file_permissions?.join(', ') || 'Choose'}}"
							[error]="condition?.invalidResourceTypes"
							id="{{'collaborationRuleDropdownResourceType' + conditionIndex}}">
				<ul>
					<li *ngFor="let resourceType of filePermissionsTypes"
						(click)="toggleResourceType(condition, resourceType); $event.stopPropagation();">
						<checkbox (click)="$event.preventDefault();"
								  [model]="condition.data?.file_permissions?.indexOf(resourceType) > -1">
							{{resourceType}}
						</checkbox>
					</li>
				</ul>
			</app-dropdown-c>

			<!--regex-->
			<div *ngIf="(condition.type === dic.CONSTANTS.collaborationProtectionRule.types.keywords.name || condition.type === dic.CONSTANTS.collaborationProtectionRule.types.addresses.name) && condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.regex"
					class="flex-row gap-1 justify-content-center align-items-center">
				<span>/</span>
				<input type="text" maxlength="500" style="width: 150px;"
					   placeholder="Regex (JavaScript)"
					   [(ngModel)]="condition.data.regex"/>
				<span>/</span>
				<input type="text" style="width: 60px;"
					   placeholder="Flags"
					   [(ngModel)]="condition.data.regex_flags"/>
			</div>
		</ng-container>

		<i class="zmdi zmdi-close text-danger hvr-darken cursor-pointer px-3 py-2 animated fadeIn" tooltip="Remove condition"
		   *ngIf="(condition.isException ? true : newRule.conditions.length > 1) || conditionArr.length > 1"
		   (click)="cancelNewRuleCondition(orIndex, conditionIndex)"></i>
	</div>
</ng-template>

<!--condition values popup-->
<popup-c *ngIf="valuesPopup?.show"
		 head="Add or edit {{valuesPopup.name}}"
		 subTitle="{{valuesPopup.subtitle}}"
		 (closeCb)="valuesPopup.show = false"
		 (confirmCb)="applyPopupCondition(conditionInEdit)"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}" size="medium">
	<div class="flex-column f-1-0 vSpace2 add-action-and-list" style="overflow: auto;">
		<form novalidate >
			<div class="add-single-item flxRow hSpace1">
				<input class="emailType" style="margin: 0; width: 90%;" required
					   [(ngModel)]="valuesPopup.input"
					   [ngModelOptions]="{standalone: true}"
					   (ngModelChange)="isValueChanged(conditionInEdit);"
					   type="text"
					   placeholder="{{valuesPopup.placeholder}}"
					   (keypress)="handleKeypress($event, conditionInEdit)"
				/>
				<btn-c [isDisabled]="!valuesPopup.input || conditionInEdit.invalidInput"
					   (action)="isValueAddedToList(conditionInEdit);">
					Add
				</btn-c>
			</div>
		</form>
		<div class="listTable alternated flxClmn f-1-0">
			<table>
				<thead>
				<tr>
					<th>
						{{ valuesPopup.name.slice(0, -1) }}
					</th>
					<th style="width:50px;">
					</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let record of valuesPopup.currentList">
					<td>
						<div class="name ellipsis">
							<div class="name ellipsis">
								<div tooltip="{{record}}" placement="top">
									{{record}}
								</div>
							</div>
						</div>
					</td>
					<td>
						<a (click)="isValueRemoved(conditionInEdit, record)" class="opener closeRed" style="padding-left: 10px;">
								<span style="padding: 0;">
									<i class="zmdi zmdi-close" style="position: relative;"></i>
								</span>
						</a>
					</td>
				</tr>
				</tbody>
			</table>
			<div class="w100 flxClmn-center" style="flex:1 0; text-align: center; color: darkgrey;"
				 *ngIf="!valuesPopup.currentList?.length">
				<span>No {{conditionInEdit?.data?.matchType === dic.CONSTANTS.ruleMatchType.exactMatch ? valuesPopup.name : "values"}} in list</span>
			</div>
		</div>
		<div class="flxRow-start hSpace1 list-csv-action">
			<a style="margin: 0 8px 0 0; padding : 0;" class="hSpace05" (mouseover)="mouseOverAttachment = true;"
			   ngfDrop
			   ngfSelect
			   [(file)]="valuesPopup.file"
			   (fileChange)="importConditionListFromCsv(valuesPopup.file,conditionInEdit)"
			   [(validDrag)]="validDrag"
			   [(invalidDrag)]="invalidDrag"
			   [ngClass]="{'drag-and-drop-hover': validDrag, 'dragOverClassObj': validDrag, 'hover': mouseOverAttachment}"
			   accept='.csv'
			>
				<i class="far fa-file-import"></i>
				<span class="action-name" tooltip='A column named "{{valuesPopup.name.slice(0,-1)}}" should contain the values'>Import from CSV</span>
			</a>
			<a class="hSpace05" style="margin: 0 0 0 8px; padding : 0;"
			   (click)="exportConditionListToCsv(conditionInEdit)"
			   [ngClass]="{'disabled': !valuesPopup.currentList.length}">
				<i class="far fa-file-export"></i>
				<span class="action-name">Export to CSV</span>
			</a>
		</div>
	</div>
</popup-c>

<!--attachment type popup-->
<popup-c *ngIf="attachmentTypesPopup?.show"
		 head="Select Attachment Types"
		 subTitle="Rule will be triggered if at least one of the selected attachment types is found in the attached files"
		 width="700px" height="auto"
		 (closeCb)="attachmentTypesPopup = null"
		 (confirmCb)="applyAttachmentTypesPopup();"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">

	<div class="flex-column f-1-0 vSpace2 danger-message">
		<div class="flex-column f-1-0 gap-2 position-relative" style="overflow: auto;">
			<div class="position-absolute" style="top: 10px; z-index: 10; left: 10px;">
				<checkbox id="allAttachmentTypes" [(model)]="attachmentTypesPopup.all_types">
					All attachment types
				</checkbox>
			</div>
			<div *ngIf="attachmentTypesPopup.all_types" class="d-flex centralize w-100 position-absolute" style="top: 0; min-height: 500px; height: 100%; z-index: 9; font-weight: bold; background-color: #ffffffbf;">
				<span>all attachment types are enabled</span>
			</div>
			<trustifi-table-c
				class="trustifi-table" style="min-height: 500px; flex: 1 0; overflow: auto; z-index: 5; background: #fdfdfd; padding: 5px;"
				[list]="attachmentTypesPopup.fileTypesList"
				[headers]="[
					{text:'Name', sortKey:'display', width: '45%'},
					{text:'Extension', width: '55%'},
				]"
				[cellsPrototype]="[
					{textKey: 'display'},
					{html: 'typeCell'},
				]"
				(searchFunction)="searchAttachmentTypes($event.searchTerm, $event.activeFilters)"
				[options]="{
					itemUniqueIdentifier: 'display',
					itemsNameSingular: 'file type',
					showRadioButtons: true,
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<div *ngIf="cellId === 'typeCell'">
					<span style="text-overflow: unset; white-space: normal;">
						{{item.extension ? item.extension.join(', ') : ''}}
					</span>
					</div>
				</ng-template>
			</trustifi-table-c>
		</div>
	</div>
</popup-c>

<sensitivity-type-c
	*ngIf="modalData?.openSensitivityTypesPopup"
	[data]="modalData"
	[allTypes]="sensitivity_types"
	[doNotDeleteTypes]="[]"
	[hideAddTypesBtn]="true"
	[selectedTypes]="conditionInEdit.data.sensitivity_types"
	(updateCb)="updateTypes($event.types, $event.newTypes)"
	(cancelCb)="cancelSensitivityTypesPopup()">
</sensitivity-type-c>

